// @ts-nocheck

import { createSelector } from 'reselect';

import { selectEntitiesMatchesEntity } from '../../selectors/entities/matches/entitiesMatchesPrimary.selector';
import { selectRuntimeLicence } from '../../selectors/runtime/runtimePrimary.selector';
import {
  selectUserConnected,
  selectUserJwtToken,
  selectUserRealMoney,
  selectUserSessionId,
} from '../../selectors/user/userPrimary.selector';
import { type Selector } from '../../types/selectors';

const selectIsVisible: Selector<boolean> = createSelector(
  [selectEntitiesMatchesEntity],
  (match) => !match || !!(match?.bets?.length ?? 0) > 0,
);

const selectLegalWrapperProps = createSelector(
  [
    selectUserConnected,
    selectUserRealMoney,
    selectIsVisible,
    selectRuntimeLicence,
    selectUserJwtToken,
    selectUserSessionId,
  ],
  (connected, realMoney, isVisible, licence, jwt, sessionId) => ({
    connected,
    realMoney,
    isVisible,
    licence,
    jwt,
    sessionId,
  }),
);

export default selectLegalWrapperProps;
